module.exports = __webpack_public_path__ + "img/pro_s3_img3.76c86ff4.jpg";